<div class="table-page">

  <ng-content select="[table-toolbar]" #filters></ng-content>


  <div class="table-input-filters">
    <ng-content select="[table-filters]"></ng-content>
  </div>

  <div class="table-card">
    <div class="table-scroll">
      <table class="table-grid">
        <ng-content select="thead"></ng-content>
        <ng-content select="tbody"></ng-content>
      </table>
    </div>

    <div class="table-footer">
      <ng-content select="[table-footer]"></ng-content>
    </div>
  </div>

</div>